<template>
    <div id="af3-shortcode-one-pager-gallery-component">
        <div class="af3-shortcode-one-pager-gallery-component-image-container">
            <img class="af3-shortcodes-single-gallery-component-image" :src="floorplan.image.url" :alt="floorplan.image.alt" />
            <button class="zoom-button" @click="showLightbox()">
                <span class="zoom-icon">+</span>
            </button>
            <vue-easy-lightbox
                :visible="visible"
                :imgs="[floorplan.image.url]"
                :index="0"
                @hide="handleHide"
            />
        </div>
        <div class="af3-shortcode-one-pager-gallery-component-content">
            <div class="af3-shortcode-one-pager-gallery-component-content-title">
                <span v-html="floorplan.title"></span>
            </div>
            <div class="af3-shortcode-one-pager-gallery-component-content-data">
                <span class="af3-shortcode-one-pager-gallery-component-content-data-bedrooms">{{ floorplan.bedrooms }} BD | {{ floorplan.bathrooms }} BTH | {{ floorplan.size_max }} SQFT.</span>
                <span class="af3-shortcode-one-pager-gallery-component-content-data-price">Starting at <span v-dollar-format="floorplan.price_min"></span></span>
            </div>
        </div>
    </div>

</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive  } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';

export default defineComponent({
    components: {VueEasyLightbox },
   
    props: { 
        floorplan: {
            type: Object,
            required: true
        }
    },

    setup(props) { 
        const visible = ref(false);

        const showLightbox = () => {
            visible.value = true;
        };

        const handleHide = () => {
            visible.value = false;
        };

         

    return {
        visible,
        showLightbox,
        handleHide
    };
  },


  
  
});
</script>